import { derived, writable, Writable } from "svelte/store";
import Cookies from 'js-cookie';
import type { LatLng, SearchAddressResult } from "../../../typings/Location";
import { jsonParseHelper } from "../../utilities/StringHelpers";

class UserStore {
    public userAddress: Writable<SearchAddressResult>;
    public userGeoCoords: Writable<LatLng>;

    constructor() {
        this.userAddress = writable(jsonParseHelper(Cookies.get('savedUserAddress')));
        this.userAddress.subscribe(value => {
            if (!value) { return; }
            Cookies.set('savedUserAddress', JSON.stringify(value));
        });

        this.userGeoCoords = writable(jsonParseHelper(Cookies.get('savedCoords')));
        this.userGeoCoords.subscribe(value => {
            if (!value) { return; }
            Cookies.set('savedCoords', JSON.stringify(value));
        });
    }

    get displayAddress() {
        // Use derived to access writable values and export as readonly
        return derived([this.userAddress], ([$address]) => {
            return $address.address.freeformAddress;
        });
    }
}
export const userStore = new UserStore();